import React, { useEffect, useState } from 'react'
import { exploreOutline, homeFill, homeOutline, likeFill, likeOutline, messageFill, messageOutline, postUploadOutline } from './SvgIcons'
import { Link, useLocation } from 'react-router-dom';
import ProfileDetails from './ProfileDetails';
import NewPost from './NewPost';
import { useSelector } from 'react-redux';
import SearchBox from './SearchBar/SearchBox';
import { ClickAwayListener } from '@mui/material';
import BottomNav from './BottomNav';
import Notifications from './Notifications';

const Header = () => {

    const { user } = useSelector((state) => state.user);

    const [profileToggle, setProfileToggle] = useState(false)
    const [newPost, setNewPost] = useState(false);
    const [notificationToggle, setNotificationToggle] = useState(false);

    const location = useLocation();
    const [onHome, setOnHome] = useState(false);
    const [onChat, setOnChat] = useState(false);

    useEffect(() => {
        setOnHome(location.pathname === "/")
        setOnChat(location.pathname.split('/').includes("direct"))
    }, [location]);

    return (
        <nav className="fixed top-0 w-full border-b bg-white z-10 transition-all duration-300">
            {/* Mobile top bar */}
            <div className="flex sm:hidden flex-row justify-between items-center py-2.5 px-4 h-[3.25rem]">
                {/* Logo — left on mobile */}
                <Link to="/">
                    <img draggable="false" className="w-[90px] object-contain" src="/logo.svg" alt="Instagram Logo" />
                </Link>

                {/* Right icons — only message icon on mobile (bottom nav handles rest) */}
                <div className="flex items-center gap-4">
                    <Link to="/direct/inbox" className="p-1">
                        {onChat ? messageFill : messageOutline}
                    </Link>
                </div>
            </div>

            {/* Desktop nav bar */}
            <div className="hidden sm:flex flex-row justify-between items-center py-2 px-4 md:px-6 xl:w-4/6 xl:px-8 mx-auto relative">

                {/* Logo */}
                <Link to="/">
                    <img draggable="false" className="mt-1.5 w-[103px] h-full object-contain" src="/logo.svg" alt="Instagram Logo" />
                </Link>

                <SearchBox />

                {/* Desktop icons */}
                <div className="flex items-center space-x-6 mr-5">
                    <Link to="/">{profileToggle || !onHome ? homeOutline : homeFill}</Link>
                    <Link to="/direct/inbox">{onChat ? messageFill : messageOutline}</Link>
                    <div onClick={() => setNewPost(true)} className="cursor-pointer">{postUploadOutline}</div>
                    <span>{exploreOutline}</span>
                    <div onClick={() => setNotificationToggle(!notificationToggle)} className="cursor-pointer">
                        {notificationToggle ? likeFill : likeOutline}
                    </div>
                    <div onClick={() => setProfileToggle(!profileToggle)} className="rounded-full cursor-pointer h-7 w-7 p-[0.5px] border-2 border-transparent hover:border-black">
                        <img draggable="false" loading="lazy" className="w-full h-full rounded-full object-cover" src={user.avatar} alt="" />
                    </div>
                </div>

                {profileToggle &&
                    <ProfileDetails setProfileToggle={setProfileToggle} />
                }

                {notificationToggle &&
                    <ClickAwayListener onClickAway={() => setNotificationToggle(false)}>
                        <div className="absolute right-0 top-full mt-1 z-50">
                            <Notifications />
                        </div>
                    </ClickAwayListener>
                }
            </div>

            <NewPost newPost={newPost} setNewPost={setNewPost} />

            {/* Mobile Bottom Nav */}
            <BottomNav newPost={newPost} setNewPost={setNewPost} />
        </nav>
    )
}

export default Header